export default __webpack_public_path__ + "static/media/parenting.d0eb0cd1.jpeg";